
import { settings } from '../../../settings/settings-util';
import watch from 'redux-watch';

export default class InputboxAutofocus
{
    constructor(passedSettings)
    {
        this._settings = passedSettings || settings;
        this._isSet = false;
    }

    static getDefaultSettings()
    {
        return settings;
    }

    getReducer()
    {
        return (store = {}) => { return store; };
    }

    initialize(store)
    {
        this._store = store;

        let watchLoc = `${this._settings.stateLocations.Window.Base}.${this._settings.stateLocations.Window.IsMinimized}`;
        let watcher = watch(this._store.getState, watchLoc);
        this._store.subscribe(watcher((newVal, oldVal, objectPath) =>
        {
            if(!newVal && !this._isSet)
            {
                if (this.isDesktop()) {
                  this.setFocus(this._settings.classNames.inputboxTextAreaClassName);
                } else {
                  this.setFocus(this._settings.classNames.headerClassName);
                }
            }
        }))
    }

    setFocus(className)
    {
        let elm = document.querySelector(`.${className}`);

        if (elm) {
            let rect = elm.getBoundingClientRect();
            let isVis = rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) &&
                rect.width > 0 &&
                rect.height > 0;

            if (isVis) {
                let tabIndex = elm.getAttribute('tabindex');
                if (elm.tagName !== 'INPUT') elm.setAttribute('tabindex', '-1');
                elm.focus();
                this._isSet = false;
            } else {
                this._isSet = true;
                setTimeout(() => { this.setFocus(className); }, 50);
            }
        } else {
            this._isSet = true;
            setTimeout(() => { this.setFocus(className); }, 50);
        }
    }

    isDesktop()
    {
        let deviceType = this._store.getState()[this._settings.stateLocations.DeviceType];
        if(!!deviceType)
        {
            return deviceType === this._settings.mobileConstants.deviceTypes.desktop
        }

        return true;
    } 
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/inputbox-autofocus/src/inputbox-autofocus.js